import React from 'react'
import { useNavigate } from 'react-router-dom'

import Button from '@components/Button'

// Avançar e voltar entre as questões de uma mesma conversão, sem passar pela
// lista.
//
// Um caderno tem dezenas de questões e a curadoria as revisa em sequência.
// Voltar à lista a cada uma custa dois cliques e uma rolagem até onde se
// estava — e é o tipo de atrito que faz quem revisa aprovar em lote para não
// repetir o caminho.
//
// A ordem é a do caderno, e não a da aprovação: assim a numeração na tela bate
// com a do PDF que está aberto ao lado.

interface Props {
	// Os identificadores das questões da conversão, na ordem do caderno.
	siblings: readonly number[]

	current: number

	// Preservado na navegação para que a próxima questão saiba de qual conversão
	// veio, e continue oferecendo o avançar.
	generationId: string
}

export default function QuestionPager({
	siblings,
	current,
	generationId,
}: Props) {
	const navigate = useNavigate()
	const index = siblings.indexOf(current)

	if (index < 0 || siblings.length < 2) {
		return null
	}

	const go = (to: number) =>
		navigate(
			`/revisar-questoes/${String(siblings[to])}?geracao=${generationId}`
		)

	return (
		<div className='flex items-center gap-3'>
			<Button
				variant='outline'
				className='!px-3 !py-2'
				disabled={index === 0}
				onClick={() => go(index - 1)}
			>
				<>← Anterior</>
			</Button>

			<span className='text-sm text-gray'>
				{index + 1} de {siblings.length}
			</span>

			<Button
				variant='outline'
				className='!px-3 !py-2'
				disabled={index === siblings.length - 1}
				onClick={() => go(index + 1)}
			>
				<>Próxima →</>
			</Button>
		</div>
	)
}
